import { render, staticRenderFns } from "./addEmployee.vue?vue&type=template&id=2e19b1b4&scoped=true&"
import script from "./addEmployee.vue?vue&type=script&lang=ts&"
export * from "./addEmployee.vue?vue&type=script&lang=ts&"
import style0 from "./addEmployee.vue?vue&type=style&index=0&id=2e19b1b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e19b1b4",
  null
  
)

export default component.exports